
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/aws/privatelink",
      function () {
        return require("private-next-pages/security/aws/privatelink.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/aws/privatelink"])
      });
    }
  